module.exports = __webpack_public_path__ + "img/passed-away-1-min.a4a43276.png";